import { RouteObject } from "react-router-dom";
import AssetManagementDashboard from "./components/landing";
export interface DashboardRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: DashboardRoute[];
}
export const axDashboardRoutes: DashboardRoute[] = [
  {
    path: "ax/dashboard",
    element: <AssetManagementDashboard />,
  },
];
